import { DATA as PYTHON_SYLLABUS } from "./Syllabus/python";
import { DATA as C_SYLLABUS } from "./Syllabus/c_cpp_ds";
import { DATA as DS1_SYLLABUS } from "./Syllabus/ds1";
import { DATA as DS2_SYLLABUS } from "./Syllabus/ds2";
import { DATA as computervision_SYLLABUS } from "./Syllabus/computervision";
import { DATA as fullstack_SYLLABUS } from "./Syllabus/fullstack";
import { DATA as iot_SYLLABUS } from "./Syllabus/iot";
import { DATA as computerapplications_SYLLABUS } from "./Syllabus/computerapplications";
import { DATA as graphicdesign_SYLLABUS } from "./Syllabus/graphicdesign";

export const DATA = {
  "Programming Language": {
    1: {
      name: "C, C++, Data Structures",
      icon: "/assets/images/courses/c_cpp_ds.png",
      sname: "c_programming",
      syllabus: C_SYLLABUS,
      type: 1,
    },
    2: {
      name: "Python Programming",
      icon: "/assets/images/courses/python.svg",
      sname: "python_programming",
      syllabus: PYTHON_SYLLABUS,
      type: 1,
    },
  },
  "Artificial Intelligence": {
    1: {
      name: "Data Science - Level I",
      icon: "/assets/images/courses/data_science1.png",
      sname: "data_science_1",
      syllabus: DS1_SYLLABUS,
      type: 2,
    },
    2: {
      name: "Data Science - Level II",
      icon: "/assets/images/courses/data_science2.png",
      sname: "data_science_2",
      syllabus: DS2_SYLLABUS,
      type: 2,
    },
    3: {
      name: "Computer Vision",
      icon: "/assets/images/courses/computer_vision.png",
      sname: "computer_vision",
      syllabus: computervision_SYLLABUS,
      type: 2,
    },
    4: {
      name: "IoT Systems",
      icon: "/assets/images/courses/iot.png",
      sname: "internet_of_things",
      syllabus: iot_SYLLABUS,
      type: 2,
    },
  },
  "Web Development": {
    1: {
      name: "Full Stack Development",
      icon: "/assets/images/courses/web-development.png",
      sname: "html_css_and_js",
      syllabus: fullstack_SYLLABUS,
      type: 3,
    },
  },
  // 'Mobile App Development': {
  //     1: {
  //         name: 'ANDROID PROGRAMMING',
  //         icon: '/assets/images/courses/android.svg',
  //         sname: 'android_programming',
  //         syllabus: PYTHON_SYLLABUS,
  //         type: 4,
  //     },
  // },
  "Graphic Designing": {
    1: {
      name: "Graphic Designing",
      icon: "/assets/images/courses/graphic_design.png",
      sname: "graphic_designing",
      syllabus: graphicdesign_SYLLABUS,
      type: 5,
    },
  },
  "Other Courses": {
    1: {
      name: "Foundation Course",
      icon: "/assets/images/courses/computer.png",
      sname: "computer_foundation",
      syllabus: computerapplications_SYLLABUS,
      type: 6,
    },
    // 2: {
    //   name: "Hardware and Networking",
    //   icon: "/assets/images/courses/networking.png",
    //   sname: "hardware_and_netwroking",
    //   syllabus: PYTHON_SYLLABUS,
    //   type: 6,
    // },
    // 3: {
    //   name: "Tally and Taxation",
    //   icon: "/assets/images/courses/tally.png",
    //   sname: "tally_and_taxation",
    //   syllabus: PYTHON_SYLLABUS,
    //   type: 6,
    // },
  },
};
